import { useTranslation } from 'react-i18next';

import { asyncJobProcessCatalogService } from '@/api/domains/catalog/asyncJobProcess/asyncJobProcess.service';
import type { AsyncJobProcess } from '@/api/domains/catalog/asyncJobProcess/asyncJobProcess.types';
import { useCatalogLoader } from '@/hooks/ui/useCatalogLoader';
import { useUI } from '@/hooks/ui/useUI';


export interface UseAsyncJobProcessesResult {
  asyncJobProcesses: AsyncJobProcess[];
  isLoaded: boolean;
}

export function useAsyncJobProcesses(): UseAsyncJobProcessesResult {
  const { t: translate } = useTranslation(['asyncJob']);
  const { showNotification } = useUI();

  const { data, isLoaded } = useCatalogLoader<AsyncJobProcess>(
    (signal) => asyncJobProcessCatalogService.getAsyncJobProcesses(signal),
    (item) => ({ value: item.code, label: item.label }),
    [],
    false,
    () => { showNotification('error', translate('asyncJob:messages.loadError')); },
  );

  return { asyncJobProcesses: data, isLoaded };
}
